'use strict';

require('shave');

var Truncate = function(config) {

  var self = this;
  var $description = $(config.description);

  self.parseDescriptions = function() {
    $description.each(function() {
      var $this = $(this);
      $this.addClass('is-truncated');
      $this.shave(50);
    });
  }

  self.destroy = function() {
    $description.each(function() {
      var $this = $(this);

      if ($this.hasClass('is-truncated')) {
        var $ellipsis = $this.find('.js-shave-char');

        $ellipsis.replaceWith(' ');

        var text = $this.text();
        $this.html(text);
      }
    });
  }

  self.init = function() {
    if ($description.length) {
      self.parseDescriptions();
    }
  }
};

module.exports = Truncate;
